import { render } from "./Multiplayer.vue?vue&type=template&id=048e993e&scoped=true&ts=true&lang=html"
import script from "./Multiplayer.vue?vue&type=script&lang=ts"
export * from "./Multiplayer.vue?vue&type=script&lang=ts"

import "./Multiplayer.vue?vue&type=style&index=0&id=048e993e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048e993e"]])

export default __exports__